export class HardwareDeviceBoundElsewhereError extends Error {
  constructor() {
    super('Device is linked to another account');
    this.name = 'HardwareDeviceBoundElsewhereError';
  }
}

export class HardwareDeviceNotFoundError extends Error {
  constructor() {
    super('Device is not linked to this account');
    this.name = 'HardwareDeviceNotFoundError';
  }
}
